export const OK         = "fa fa-check";
export const ERROR      = "fa fa-times";
export const WARNING    = "fas fa-exclamation-triangle";
export const ATTENTION  = "fas fa-info";